module.exports = __webpack_public_path__ + "img/ES2103.7947829f.png";